import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { PrimaryButton, DefaultButton } from "@ane/ui-components/lib/components/Button";
import { FormActions } from "@ane/ui-components/lib/components/FormActions";
import { CommonUtilsInstance } from "@ane/core/lib/utils/CommonUtils";
import { ErrorStorageProperties } from "@ane/core/lib/models";
import { HelpRoute } from "@ane/exp-data/lib/routes/HelpRoute.utils";
import NavigationService from "@ane/core/lib/services/NavigationService";
class ErrorDisplayButtons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false
    };
  }
  render() {
    let clipboardText = "";
    try {
      clipboardText = JSON.stringify({ issue: this.props.message, description: this.props.description }, null, 2);
    } catch (e) {
      clipboardText = "Issue: " + unescape(this.props.message) + " ; Description: " + unescape(this.props.description);
    }
    return /* @__PURE__ */ jsxs(FormActions, { horizontalAlign: "start", children: [
      /* @__PURE__ */ jsx(
        PrimaryButton,
        {
          ariaLabel: "File a DRI Ticket",
          text: "File a DRI Ticket",
          target: "_blank",
          onClick: () => {
            sessionStorage.setItem(ErrorStorageProperties.expErrorIssue, this.props.message);
            sessionStorage.setItem(ErrorStorageProperties.expErrorDescription, this.props.description);
            sessionStorage.setItem(ErrorStorageProperties.expErrorClientRequestId, this.props.clientRequestId);
          },
          href: NavigationService.getCustomQueryParams(`${HelpRoute.routes.root.getSourceUrl({ source: "expErrorMessage" })}`)
        }
      ),
      /* @__PURE__ */ jsx(
        DefaultButton,
        {
          ariaLabel: "Copy full message to Clipboard",
          text: this.state.copied ? "Copied!" : "Copy to Clipboard",
          title: "Copy full error message to Clipboard",
          onClick: () => {
            CommonUtilsInstance.copyToClipboard(clipboardText);
            this.setState({ copied: true });
          }
        }
      )
    ] });
  }
}
export {
  ErrorDisplayButtons,
  ErrorDisplayButtons as default
};
//# sourceMappingURL=ErrorDisplayButtons.js.map
